/**
 * Fichier contenant des fonction jquery custom
 */


(function ($) {   
/**
 * Custom JQuery functions.
 */
$.fn.slideFadeToggle = function (speed, easing, callback) {
    return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
};

$.fn.slideFadeIn = function (speed, easing, callback) {
    return this.animate({opacity: 'show', height: 'show'}, speed, easing, callback);
};

$.fn.slideFadeOut = function (speed, easing, callback) {
    return this.animate({opacity: 'hide', height: 'hide'}, speed, easing, callback);
};
/**
 * Scroll j'usqu'à  l'élement si celui ci n'est pas visible
 * @param {Vitesse du scroll} speed 
 */
$.fn.scrollToElementIfNonVisible = function() {
    try {    
        if(this.length>0 && !this.first().isInViewport()) {           
            $('html, body').animate({
                scrollTop: this.offset().top - $('header').height()
            }, 500);
        }
    }
    catch (e){
        console.info(e);
    }
};

$.fn.isInViewport = function() {
    const rect = this[0].getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}


/**
 *  Permet de mapper un objet javascript à des elements du dom
 *  <a id='tel' data-agence-template="tel:{TelephoneFamille}" href="tel:01 77 48 77 88"><span data-agence="TelephoneFamille"></span></a>
 *  $('body').mapObject(agence,'agence');
 *  ==>
 *  <a id='tel' data-agence-template="tel:{TelephoneFamille}" href="tel:02 40 35 97 97"><span data-agence="TelephoneFamille">02 40 35 97 97</span></a>
 */
$.fn.mapObject = function(objet,mapsuffix='mapping') {
    $(this).find("[data-" +  mapsuffix+"],[data-" +  mapsuffix+"-template]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix);
        var tpl = $(this).attr("data-"+ mapsuffix +"-template");
        var value="";
        // Si un template est définit on utilise le template, sinon on utilise la variable de data-mapping
        if (tpl!=undefined) {
            properties = Object.getOwnPropertyNames(objet);
            properties.forEach(element => {
                if (objet[element]!=undefined) {
                    value = tpl.replace('{'+element+'}',objet[element]);    
                    tpl = value;
                }
            });

        } else {
            value = objet[propertyname];
        }            
        // map selon le type de tag
        if($(this)[0].tagName=="A") {
            $(this).attr('href',value);
        } else if ($(this)[0].tagName=="IMG") {
            $(this).attr('src',value);
        }        
        else {
            $(this).html(value);
        }
    });

    // Affiche les éléments data-mapping-show="NomDeLaProprite" uniquement si NomDeLaPropiete n'est pas vide
    $(this).find("[data-" +  mapsuffix+"-show]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix+ "-show");
        var value= objet[propertyname];
        if(typeof(value)!=='undefined' &value!==null) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    // Masque les éléments data-mapping-hide="NomDeLaProprite" uniquement si NomDeLaPropiete n'est pas vide
    $(this).find("[data-" +  mapsuffix+"-hide]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix+ "-hide");
        var value= objet[propertyname];
        if(typeof(value)!=='undefined' &value!==null) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
}


/**
 *  Function globale Jquery de gestion des calls ajax
 *   - affiche les éléments ".ajax-loader" (ou cssSelectorLoader)
 *   - change l'opacité du container pendant le call ajax
 *  Utilisation :
 *   $("#container").loading(promise, cssSelectorLoader );
 */
/**
 * Active les elements de type ajax-loader
 */
$.fn.loading = function (promise,cssSelectorLoader=".ajax-loader")
{
    var self = this;
    this.find(".ajax-error").remove();
    // Start loading
    $(cssSelectorLoader).css("display","inline-block");
    this.css("opacity","0.4"); 
    if (promise!=null) {                         
        promise.then(function(e) {
            // Stop loading
            $(cssSelectorLoader).hide();
            self.css("opacity","1");                
        })
        promise.catch(function(e) {
            // Stop loading
            $(cssSelectorLoader).hide();
            self.css("opacity","1");                
            // Ajout d'un message d'erreur        
            if (e.responseJSON && e.responseJSON.data) {
                self.append("<div class=\"ajax-error\">"+ e.responseJSON.data +"</div>");
            } else {
                self.append("<div class=\"ajax-error\">Erreur inconnue détectée</div>");
            }
            // Supprime le message d'erreur au bout de 3 secondes
            setTimeout(function() {
                $("div.ajax-error").remove();
            },3000);
        });                 
    }       
    return this;
}; 


})(jQuery);